import { render, staticRenderFns } from "./CardPercentualAlertasDashboardOperacao.vue?vue&type=template&id=54cb0473&scoped=true&lang=pug"
import script from "./CardPercentualAlertasDashboardOperacao.vue?vue&type=script&lang=js"
export * from "./CardPercentualAlertasDashboardOperacao.vue?vue&type=script&lang=js"
import style0 from "./CardPercentualAlertasDashboardOperacao.vue?vue&type=style&index=0&id=54cb0473&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54cb0473",
  null
  
)

export default component.exports